import React from "react";
import Select from 'react-select';

import "./dropdown.css";


const InputDropdown = ({ iconClass, placeholder, iconSize, isInvalid, onChange, errorMessage, inputKey, maxWidth, itemList, isDisabled, defaultValue}) => { 
    return (
        <div>
        <div className="input-dropdown-div" style={maxWidth && {
            maxWidth: maxWidth
        }}>
            <div className={
                isInvalid ?
                    'input-dropdown-control row input-dropdown-invalid'
                    :
                    "input-dropdown-control row"
            }>
                <div className="col-2 input-dropdown-icon-div">
                        <i className={"bi " + iconClass + " input-dropdown-icon"} style={iconSize && { fontSize: iconSize }}></i>
                </div>
                    <div className="col">
                        <Select
                            id={inputKey}
                            options={itemList}
                            className="react-select-container"
                            classNamePrefix="react-select"
                            placeholder={placeholder}
                            onChange={(e) => onChange(e)}
                            isDisabled={isDisabled}
                            value={defaultValue}
                    />
                </div>
            </div>
            </div>
            <span className="input-dropdown-invalid-text">{errorMessage}</span>
            
        </div>
    );
}


export default InputDropdown;
